import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  margin: 0;
  left: 0;
  top: 0;
  width: 100%;
  height: calc(100% - 80px);

  display: flex;
  flex-direction: column;
`;

export const Upper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.km6};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  flex-grow: 1;

  padding: ${({ theme }) => theme.spacing.km10};
  background: ${({ theme }) => theme.color.background.neutral.weak};

  color: ${({ theme }) => theme.color.icon.neutral.default};
`;

export const Bottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  margin-top: auto;

  min-height: 120px;
  padding: ${({ theme }) => theme.spacing.km4};
`;
